<template>
  <main>
    <UserProfile />
  </main>
</template>

<script>
import UserProfile from "../components/UserProfile/UserProfile.vue";

export default {
  components: { UserProfile },
};
</script>
